class MainNavigation {

  defaultConfig = {
    openBodyClass: 'main-navigation--open',
    toggleOpenClass: 'main-navigation__toggle--open',
    mobileScreenSizeLimit: 1023
  };

  constructor(config) {
    this.config = Object.assign({}, this.defaultConfig, config);
    this.storeDomElements();

    this.initToggle();
    this.initLevel1Links();
    this.initLevel2CloseButton();
    this.initLevel3CloseButton();
  }

  storeDomElements() {
    this.domElements = {};
    this.domElements.body = $('body');
    this.domElements.document = $(document);
    this.domElements.toggle = this.config.toggleElement;
    this.domElements.navigation = this.config.navigationElement;

    this.domElements.mainNavLevel1Container = this.config.navigationElement.find(
        '.main-navigation__main__container-level-1');
    this.domElements.mainNavLevel2Container = this.config.navigationElement.find(
        '.main-navigation__main__container-level-2');
    this.domElements.mainNavLevel2ContainerHeadline = this.config.navigationElement.find(
        '.main-navigation__main__container-level-2__headline');
    this.domElements.mainNavLevel2ContainerContent = this.config.navigationElement.find(
        '.main-navigation__main__container-level-2__content');
    this.domElements.mainNavLevel3Container = this.config.navigationElement.find(
        '.main-navigation__main__container-level-3');
    this.domElements.mainNavLevel3ContainerHeadline = this.config.navigationElement.find(
        '.main-navigation__main__container-level-3__headline');
    this.domElements.mainNavLevel3ContainerContent = this.config.navigationElement.find(
        '.main-navigation__main__container-level-3__content');
    this.domElements.mainNavLevel3CloseBtn = this.config.navigationElement.find(
        '.main-navigation__main__container-level-3__close');

    return true;
  }

  initToggle() {
    this.domElements.toggle.on('click', () => {
      this.toggleNavigation();
    });
  }

  toggleNavigation() {
    if (this.domElements.toggle.hasClass(this.config.toggleOpenClass)) {
      this.closeNavigation();
    } else {
      this.openNavigation();
    }
  }

  openNavigation() {
    this.domElements.toggle.addClass(this.config.toggleOpenClass);
    this.domElements.toggle.attr('aria-expanded', true);
    this.domElements.body.addClass(this.config.openBodyClass);
    this.addKeyListener();
  }

  closeNavigation() {
    this.domElements.toggle.focus();
    this.domElements.toggle.removeClass(this.config.toggleOpenClass);
    this.domElements.toggle.attr('aria-expanded', false);
    this.domElements.body.removeClass(this.config.openBodyClass);
    this.removeKeyListener();
    this.removeClickListener();
  }

  addKeyListener() {
    this.domElements.document.on('keydown.hamburger-navigation', event => {
      if (event.key === 'Escape') {
        this.closeNavigation();
      }
    });
  }

  removeKeyListener() {
    this.domElements.document.off('keydown.hamburger-navigation');
  }

  initClickOutsideListener() {
    this.domElements.document.on('click.hamburger-navigation', event => {
      if (!$(event.target).closest(this.domElements.navigation).length &&
          !$(event.target).closest(this.domElements.toggle).length) {
        this.closeNavigation();
      }
    });
  }

  removeClickListener() {
    this.domElements.document.off('click.hamburger-navigation');
  }

  initLevel1Links() {
    this.domElements.mainNavLevel1Container.find('> ul > li.has-subpages > a').
        on('click', event => {
          event.preventDefault();
          const $level1Item = $(event.currentTarget).parent();
          if ($level1Item.hasClass('open')) {
            this.closeLevel2();
          } else {
            $level1Item.addClass('open').siblings().removeClass('open');
            this.openLevel2($level1Item);
          }
        });
  }

  openLevel2($level1Item) {
    const level2List = $level1Item.find('> ul');
    const level2Headline = $level1Item.find('> a').text();
    this.domElements.mainNavLevel2ContainerHeadline.text(level2Headline);
    this.domElements.mainNavLevel2ContainerContent.empty().
        append(level2List.clone(true, true));
    this.domElements.mainNavLevel2Container.show();
    this.domElements.mainNavLevel2ContainerContent.find('ul > li a').first().focus();
    this.initLevel2Links();
    this.currentLevel1Item = $level1Item;
    this.addOpenLevelClass(2);
    this.closeLevel3();
  }

  closeLevel2() {
    console.log('close level 2');
    this.domElements.mainNavLevel2ContainerContent.empty();
    this.domElements.mainNavLevel2Container.hide();

    if (this.currentLevel1Item) {
      this.currentLevel1Item.removeClass('open');
      this.currentLevel1Item.find('> a').focus();
      this.currentLevel1Item = null;
    }
    this.removeOpenLevelClass();
  }

  initLevel2CloseButton() {
    this.domElements.mainNavLevel2ContainerHeadline.on('click', event => {
      event.preventDefault();
      this.closeLevel2();
    })
  }

  initLevel2Links() {
    this.domElements.mainNavLevel2ContainerContent.find('> ul > li.has-subpages > a').
        on('click', event => {
          event.preventDefault();
          const $level2Item = $(event.currentTarget).parent();
//          $level2Item.addClass('open').siblings().removeClass('open');
          this.openLevel3($level2Item);
        });
  }

  openLevel3($level2Item) {
    const level3List = $level2Item.find('> ul');
    const level3Headline = $level2Item.find('> a').text();
    this.domElements.mainNavLevel3ContainerHeadline.text(level3Headline);
    this.domElements.mainNavLevel3ContainerContent.empty().
        append(level3List.clone(true, true));
    this.domElements.mainNavLevel3Container.show();
    this.domElements.mainNavLevel3ContainerContent.find('ul > li a').first().focus();
    this.currentLevel2Item = $level2Item;

    this.domElements.mainNavLevel2Container.hide();
    this.addOpenLevelClass(3);
  }

  closeLevel3() {
    this.domElements.mainNavLevel3ContainerContent.empty();
    this.domElements.mainNavLevel3Container.hide();
    this.domElements.mainNavLevel2Container.show();
    if (this.currentLevel2Item) {
      this.currentLevel2Item.find('> a').focus();
      this.currentLevel2Item = null;
    }
    this.addOpenLevelClass(2);
  }

  initLevel3CloseButton() {
    this.domElements.mainNavLevel3CloseBtn.on('click', event => {
      event.preventDefault();
      this.closeLevel3();
    });

    this.domElements.mainNavLevel3ContainerHeadline.on('click', event => {
      event.preventDefault();
      this.closeLevel3();
    })
  }

  addOpenLevelClass(level) {
    this.removeOpenLevelClass();
    this.domElements.navigation.addClass('main-navigation--level-' + level + '-open');
  }

  removeOpenLevelClass() {
    this.domElements.navigation.removeClass(
        'main-navigation--level-2-open main-navigation--level-3-open');
  }
}

export default MainNavigation;
